module.exports = __webpack_public_path__ + "static/media/0D3A8FC8-9F0C-4CDF-ADF3-B2A3F0D4E6EE-min.720d3b39.jpg";